import React from "react";
import "./styles.css"; 

const BanScreen = ({ secondsLeft, onClose }) => (
  <div className="ban-screen-modal">
    <div className="ban-screen-content">
      <div className="ban-title">Блокировка за спам</div>
      <div className="ban-text">
        Слишком много запросов за короткое время.<br />
        Подождите немного — это поможет защитить сервис от перегрузки.<br />
        Доступ восстановится через:
      </div>
      <div className="ban-timer">
		  <span>{String(Math.floor(secondsLeft / 60)).padStart(2,'0')[0]}</span>
		  <span>{String(Math.floor(secondsLeft / 60)).padStart(2,'0')[1]}</span>
		  <span className="sep">:</span>
		  <span>{String(secondsLeft % 60).padStart(2,'0')[0]}</span>
		  <span>{String(secondsLeft % 60).padStart(2,'0')[1]}</span>
		</div>
		<div className="ban-glow"></div>

      <button className="ban-close-btn" onClick={onClose}>
        Закрыть приложение
      </button>
    </div>
  </div>
);

export default BanScreen;





